<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Proceso Acreditación"
          directory="Documentación - Renovación"
          :icon="'grid'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="
              () => {
                $hub.$emit('reload-table');
              }
            "
          >
            <i data-feather="refresh-ccw" class="pr-2" /> Refrescar
          </button>
        </div>
      </div>
    </div>

    <div class="mb-primary">
      <div class="d-flex justify-content-between mb-3"></div>
      <app-tab :tabs="tabsHorizontal" type="horizontal" />
    </div>
  </div>
</template>

<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";

export default {
  extends: CoreLibrary,
  name: "RenovationIndex",
  data() {
    return {
      tabsHorizontal: [
        {
          icon: "file-plus",
          name: "Iniciar Renovación",
          component: "renovation-start-index",
          permission: "",
        },
        {
          icon: "file",
          name: "Documento Renovación",
          component: "renovation-table",
          permission: "",
        },
      ],
    };
  },
};
</script>

<style></style>
